import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const VideoOn = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24, strokeWidth = 1.75 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.6055 8.83333H9.8555M16.3752 14.3867L21.0252 16.6771C21.5072 16.9705 22.013 16.7976 22 16.1856L21.9674 8.09104C21.9262 7.42667 21.5341 7.24539 20.9568 7.55242L16.3621 9.64057M5.75 18.5H14.1055C15.3481 18.5 16.3555 17.5051 16.3555 16.2778L16.3752 13.4275L16.3555 7.72222C16.3555 6.49492 15.3481 5.5 14.1055 5.5H5.75C4.50736 5.5 3.5 6.49492 3.5 7.72222V16.2778C3.5 17.5051 4.50736 18.5 5.75 18.5Z"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default VideoOn
